// i18n area 'system' — locale sq-AL (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.sq-AL.meta.json.
import type { enUS } from './system'

export const sqAL: typeof enUS = {
  diagnostics: {
    title: 'Diagnostika',
    subtitle: 'Çfarë nuk shkon, më e keqja së pari — e njëjta lente si tvirt diagnose',
    reload: 'Ringarko',
    loadError: 'Diagnoza nuk u lexua dot',
    exportBundle: 'Eksporto paketën',
    exportError: 'Paketa nuk u krijua dot',
    noProblem: 'Asnjë problem në zonat e inspektuara',
    nothingInspected: 'ASGJË nuk u inspektua — kjo nuk është certifikatë shëndeti',
    inspected: 'Të inspektuara',
    notInspected: 'TË PAINSPEKTUARA',
    localHint: 'Zonat lokale të nyjes (njësitë systemd, journal) lexohen vetëm nga CLI: tvirt diagnose --area local — rruga kur API nuk përgjigjet.',
    thresholds: 'detyra të dështuara brenda {hours} orësh, heartbeat i vonuar mbi {seconds} s',
    severity: {
      critical: 'Kritik',
      warning: 'Paralajmërim',
      unknown: 'I panjohur'
    }
  },
  explorer: {
    title: 'Eksploro burimet',
    root: 'Rrënja',
    empty: 'Asnjë burim në këtë scope',
    previewHint: 'Zgjidh një objekt për të parë parapamjen e tij',
    open: 'Hap',

    // Il deep-link ?scope= delle liste CRUD (round #109), dall'esplora (#143).
    openScoped: 'Hap listën në këtë scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Shabllon VM',
      ct: 'CT',
      ctTemplate: 'Shabllon CT',
      app: 'App',
      overlayNetwork: 'Rrjet overlay',
      networkService: 'Shërbim rrjeti',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Pool storage-i',
      disk: 'Disk',
      catalogFile: 'Skedar katalogu',
      ociRegistry: 'Regjistër OCI',
      ociImage: 'Imazh OCI',
      cephCluster: 'Klaster Ceph',
      backupDestination: 'Destinacion backup-i',
      user: 'Përdorues',
      group: 'Grup',
      role: 'Rol',
      credential: 'Kredencial',
      tag: 'Tag',
      proximityRule: 'Rregull afërsie'
    }
  },
  tags: {
    title: 'Tag',
    empty: 'Asnjë tag',
    add: 'Shto tag',
    remove: 'Hiq',
    name: 'Tag',
    value: 'Vlera',
    save: 'Ruaj',
    saveError: 'Tag-et nuk mund të ruheshin',
    loadError: 'Fjalori i tag-eve nuk mund të ngarkohej',
    noVocabulary: 'Asnjë tag i disponueshëm për këtë tip burimi',

    // A single-valued tag already set answers 409: the replacement is always
    // explicit — never an implicit substitution (design, ratified 2026-07-27).
    overwrite: 'Zëvendëso vlerën aktuale',

    // Sistema > Tag, the vocabulary surface.
    createTitle: 'Krijo tag',
    editTitle: 'Modifiko tag-un',
    nameHint: 'Shkronja, shifra, pika, vija ndarëse dhe underscore — asnjë ":" as "/"; prefiksi tvirt- është i rezervuar për platformën',
    cardinality: 'Kardinaliteti',
    cardinalitySingle: 'Një vlerë e vetme',
    cardinalityMultiple: 'Më shumë vlera',
    cardinalityHint: 'Me një vlerë të vetme, ri-caktimi i tag-ut kërkon zëvendësimin e tij',
    autoCreate: 'Vetë-krijim vlerash',
    autoCreateOn: 'Në caktim',
    autoCreateOff: 'Vetëm të deklaruara',
    autoCreateHint: 'Aktiv: caktimi i një vlere të re e krijon. Joaktiv: caktohen vetëm vlerat e deklaruara',
    values: 'Vlerat',
    noValues: 'Asnjë vlerë e deklaruar',
    addValue: 'Shto vlerë',
    duplicateValue: 'Vlerë e dyfishuar',
    kinds: 'Tipet e burimeve',
    kindsAll: 'Të gjitha',
    kindsPlaceholder: 'Të gjitha',
    kindsHint: 'Lëre bosh për të pranuar çdo tip burimi të tag-ueshëm',
    systemChip: 'Sistemi',
    deleteCascade: 'Hiq edhe caktimet',
    deleteCascadeHint: 'Një etiketë ende e caktuar ndonjë burimi refuzohet: me këtë opsion vlerat dhe të gjitha caktimet largohen bashkë me etiketën.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Krijo scope',
    editTitle: 'Riemërto scope-in',
    path: 'Shtegu',
    segment: 'Segmenti',
    segmentHint: 'Shkronja të vogla, shifra dhe vija ndarëse (DNS-1123)',
    parent: 'Prindi',
    rootChip: 'Rrënja',
    preview: 'Scope i ri',
    pickLabel: 'Scope',
    pickHint: 'Ku jeton objekti në pemën e klasterit — rrënja ose një vDC brenda saj.',
    ociCache: 'Cache OCI (override)',
    appEphemeral: 'Pool-e efemere App (override)',
    inherit: 'Trashëgo',
    inheritsFrom: 'Trashëgon nga',
    inheritsCluster: 'Trashëgon default-in e klasterit',
    inheritsNone: 'Trashëgon — asnjë pool efektiv',
    failoverProtection: 'Mbrojtja në degradim',
    networkWeight: 'Pesha e rrjetit',
    networkCeil: 'Tavani i rrjetit (Mbps)',
    protectionProtected: 'E mbrojtur',
    protectionExpendable: 'E sakrifikueshme në degradim',
    protectionDefault: 'Default-i i klasterit'
  },

  // Sistema > Informazioni (round #124, 2026-07-31): versioni piattaforma
  // nella flotta (al massimo due mid-upgrade), componenti per nodo, manuale
  // PDF servito localmente e card licenza inglobata.
  sysinfo: {
    summary: 'Versionet e platformës në klaster, komponentët e secilës nyjë, manuali i administrimit dhe licenca.',
    platformTitle: 'Platforma TVirt',
    platformSubtitle: 'Versionet e vëzhguara në nyjet e klasterit',
    versionOnNodes: '{version} në {n} nyje',
    versionOnOneNode: '{version} në 1 nyjë',
    mixedVersions: 'Më shumë se një version i platformës në klaster — i pritur vetëm gjatë një përditësimi në proces (të shumtën dy).',
    tooManyVersions: 'Më shumë se dy versione të platformës në klaster — nuk pritet kurrë, as gjatë një përditësimi: kontrollo nyjet këtu poshtë.',
    unreportedNodes: 'Ende asnjë raport versionesh nga: {nodes}',
    noVersionsYet: 'Asnjë nyjë s’i ka raportuar ende versionet e veta.',
    nodesUnavailable: 'Lista e nyjeve nuk është e dukshme me lejet e tua — versionet e platformës nuk mund të shfaqen.',
    colNode: 'Nyja',
    manualTitle: 'Manuali i administrimit',
    manualSubtitle: 'Kopje lokale, e shërbyer nga ky klaster',
    manualBody: 'Manuali i plotë TVirt në PDF, i shërbyer drejtpërdrejt nga platforma — i disponueshëm edhe në mjedise air-gapped.',
    manualLink: 'Manuali i administrimit (PDF)',
    apiExplorerTitle: 'Eksploruesi i API-së',
    apiExplorerSubtitle: 'Kontrata OpenAPI, e shfletueshme',
    apiExplorerBody: 'Kontrata e plotë OpenAPI e platformës — çdo rrugë, skemë dhe kod përgjigjeje — e shfletueshme nga shfletuesi, e shërbyer përmes kësaj nyjeje.',
    apiExplorerLink: 'Eksploro API-në',
    kubeTitle: 'Përputhshmëria me Kubernetes',
    kubeSubtitle: 'kubectl dhe mjetet e tij, përpara API-së native',
    kubeBody: 'TVirt KubeCompat projekton Pod-et, Deployment-et, Service-t, namespace-t, nyjet dhe ngjarjet në dialektin e Kubernetes — vetëm lexim, plus fshirjen e Deployment-eve. Çdo thirrje kalon nga API-ja native me lejet e tua: në kubeconfig përdor një app token si bearer.',
    kubeEndpoint: 'Endpoint për kubectl',
    kubeStatusActive: 'Aktiv — Kubernetes {version}',
    kubeStatusMissing: 'Nuk është instaluar në këtë nyje (paketa trantor-tvirt-kubecompat)',
    kubeStatusDown: 'I instaluar, por nuk përgjigjet — kontrollo njësinë trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Duke kontrolluar…'
  },

  // Licensing (round 2026-07-29): la pagina della licenza a sottoscrizione.
  licensing: {
    title: 'Licenca e klasterit',
    subtitle: 'Licencë me abonim — të shumtën një për klaster',
    absentTitle: 'Asnjë licencë e regjistruar',
    absentBody:
      'Pa një licencë të vlefshme klasteri refuzon të nisë makina virtuale të reja (VM-të e ndezura mbeten të ndezura). Regjistro product key-in e marrë me abonimin.',
    registerButton: 'Regjistro licencën',
    removeButton: 'Hiq licencën',
    state: {
      ok: 'E vlefshme',
      limitExceeded: 'Kufiri i tejkaluar',
      expired: 'E skaduar'
    },
    productKeyLabel: 'Product key',
    basisLabel: 'Baza e kufirit',
    basis: {
      concurrentVms: 'VM të ndezura njëkohësisht',
      physicalCores: 'Core fizikë (totali i klasterit)'
    },
    limitLabel: 'Kufiri',
    usageLabel: 'Përdorimi aktual',
    usageOf: '{used} nga {limit}',
    usagePartial: 'shumë e pjesshme — {n} nyje pa topologji CPU të vëzhguar',
    usageUnknown: 'i pavëzhgueshëm për momentin',
    expiresLabel: 'Skadenca',
    neverExpires: 'kurrë',
    registeredLabel: 'E regjistruar',
    gateNote:
      'Me licencë të munguar, të skaduar ose përtej kufirit klasteri refuzon të nisë makina virtuale TË REJA. VM-të e ndezura mbeten të ndezura dhe rinisjet HA nuk preken.',
    devStage:
      'Fazë zhvillimi: product key-i pranohet siç është bashkë me kufijtë e deklaruar këtu; validimi me çelës të firmosur do të vijë në një release të ardhshëm.',
    dialogTitle: 'Regjistro licencën',
    dialogExpiresHelp: 'Bosh = licenca nuk skadon kurrë',
    dialogSubmit: 'Regjistro',
    dialogError: 'Licenca nuk mund të regjistrohej.',
    removeTitle: 'Hiq licencën',
    removeBody:
      'Klasteri do të mbetet PA LICENCË: makinat virtuale të reja do të refuzojnë të nisen derisa të regjistrosh një. VM-të e ndezura mbeten të ndezura.',
    removeConfirm: 'Hiq',
    removeError: 'Licenca nuk mund të hiqej.'
  },
  rbac: {
    tabRoles: 'Rolet',
    tabGrants: 'Delegimet',
    rolesTitle: 'Rolet',
    createRoleTitle: 'Krijo rol',
    editRoleTitle: 'Modifiko rolin',
    nameHint: 'Shkronja të vogla, shifra dhe vija ndarëse; prefiksi tvirt- është i rezervuar',
    systemChip: 'Sistemi',
    permissions: 'Lejet',
    permissionsPlaceholder: 'Shto leje…',
    includedRoles: 'Role të përfshira',
    includedRolesPlaceholder: 'Shto rol…',
    grantsTitle: 'Delegimet',
    createGrantTitle: 'Krijo delegim',
    principal: 'Principal',
    principalKind: 'Tipi i principal-it',
    principalUser: 'Përdorues',
    principalGroup: 'Grup',
    role: 'Roli',
    grantRight: 'Delegim',
    grantRightChip: 'Mund të delegojë',
    grantRightLabel: 'Me të drejtë delegimi (marrësi mund ta delegojë nga ana e tij këtë rol)',
    effective: 'Efektive',
    notEffective: 'Joefektive',
    createdAt: 'Krijuar',
    scopeHint: '/shteg i saktë, /shteg/* rekurziv — delegimet ankorohen te një rrënjë e montuar (/* nuk delegohet)'
  },
  groups: {
    title: 'Grupet',
    createTitle: 'Krijo grup',
    nameHint: 'Shkronja të vogla, shifra dhe vija ndarëse; unik në scope',
    members: 'Anëtarët',
    membersTitle: 'Anëtarët',
    membersPlaceholder: 'Shto përdorues…',
    noMembers: 'Asnjë anëtar',
    realmMappings: 'Përkthimet e realm-eve',
    realmMappingsTitle: 'Përkthimet e realm-eve',
    realmMappingsHint:
      'Me çfarë përkon ky grup në secilin realm të jashtëm. Anëtarësia lexohet nga direktoria në momentin e hyrjes: një grup direktorie që askush s’e përkthen këtu injorohet, dhe foleja e grupeve nuk zgjidhet — duhet rrafshuar nga ana e direktorisë.',
    realm: 'Realm',
    externalGroup: 'Grupi i jashtëm',
    addRealmMapping: 'Shto përkthim',
    removeRealmMapping: 'Hiq përkthimin',
    noRealmMappings: 'Asnjë përkthim realm-i',

    // Dialog di creazione a sezioni (round realm-wizard, 2026-08-03): Generale
    // più la superficie di mappatura coi realm esterni, con l'empty state
    // parlante.
    sectionGeneral: 'Të përgjithshme',
    mappingsNoRealms: 'Asnjë realm i jashtëm i konfiguruar — sipërfaqja e përkthimit zhbllokohet sapo të ekzistojë një realm.',
    mappingsNoRealmsLink: 'Hap tab-in Realm-et dhe SSO',

    // L'obbligo MFA imposto dal gruppo (round #178 metà B): OR puro — un
    // gruppo può solo AGGIUNGERE l'obbligo, mai toglierlo.
    mfaRequired: 'Detyrimi MFA',
    mfaRequiredChip: 'E imponon MFA-në',
    mfaNotRequiredChip: 'Asnjë detyrim',
    mfaRequiredHint:
      'OR i pastër: një grup mund t’ua SHTOJË detyrimin e faktorit të dytë anëtarëve të vet — edhe identiteteve të jashtme, përmes përkthimeve të realm-eve — kurrë t’ua heqë. Vlen nga hyrja e ardhshme: sesionet e hapura nuk mbyllen.'
  },
  users: {
    title: 'Përdoruesit',
    createTitle: 'Krijo përdorues',
    editTitle: 'Modifiko përdoruesin',
    username: 'Emri i përdoruesit',
    usernameHint: 'Shkronja të vogla, shifra, pika dhe vija ndarëse',
    displayName: 'Emri i shfaqur',
    enabled: 'I aktivizuar',
    state: 'Gjendja',
    enabledChip: 'I aktivizuar',
    disabledChip: 'I çaktivizuar',
    lockedChip: 'I bllokuar',
    password: 'Fjalëkalimi',
    passwordSetChip: 'I vendosur',
    mustChangeChip: 'Për t’u ndryshuar',
    initialPassword: 'Fjalëkalimi fillestar',
    initialPasswordHint: 'Përdoruesi do të duhet ta ndryshojë në hyrjen e parë',
    lastLogin: 'Hyrja e fundit',
    neverLoggedIn: 'Asnjëherë i futur',
    setPasswordTitle: 'Vendos fjalëkalimin',
    setPasswordHint: 'Zëvendësim administrativ — kërkon fjalëkalimin tënd (mënyra sudo) dhe e detyron përdoruesin ta ndryshojë në hyrjen e ardhshme.',
    operatorPassword: 'Fjalëkalimi yt',
    unlock: 'Zhblloko llogarinë',
    revokeTitle: 'Revoko sesionet',
    revokeBody: 'Të gjitha sesionet aktive të këtij përdoruesi përfundohen menjëherë.',
    revokeIncludeTokens: 'Revoko edhe app token-ët',
    revokeConfirm: 'Revoko',

    // Dialog standard (round #156): dettagli completi, tab account/sicurezza.
    tabAccount: 'Llogaria',
    tabSecurity: 'Siguria',
    usernameImmutableHint: 'Emri i përdoruesit është identiteti i llogarisë — i fiksuar në krijim',
    groups: 'Grupet',
    noGroups: 'Asnjë grup',
    mustChangePassword: 'Ndryshim i detyrueshëm fjalëkalimi',
    failedAttempts: 'Tentativa hyrjeje të dështuara',
    lockedUntil: 'I bllokuar deri më',

    // Identity tabs (2026-08-03): Sistema > Utenti è diventata una sezione a
    // tab sul modello di /system/rbac — utenti, gruppi, realm esterni.
    tabUsers: 'Përdoruesit',
    tabGroups: 'Grupet',
    tabRealms: 'Realm-et dhe SSO',
    tabMfa: 'MFA',

    // Tab MFA (task #178): la vista del secondo fattore.
    mfa: {
      title: 'Faktori i dytë (MFA)',
      methodsTitle: 'Metodat e disponueshme',
      methodsSubtitle: 'Ajo që ky instalim di të verifikojë si faktor të dytë',
      methodsError: 'Regjistri i metodave nuk mund të ngarkohej',
      builtinChip: 'I integruar',
      enrollableChip: 'Enrollment në TVirt',
      delegatedChip: 'I menaxhuar nga jashtë',
      state: 'Gjendja',
      stateActive: 'Aktiv',
      statePending: 'Në pritje të enrollment-it',
      stateNone: 'I paregjistruar',
      required: 'Detyrimi MFA',
      requiredChip: 'I detyrueshëm',
      notRequiredChip: 'Jo i detyrueshëm',
      enrolledAt: 'Enrollment më',
      enrolledMethods: 'Metoda të regjistruara',
      noMethods: 'Asnjë enrollment',
      codesRemaining: 'Kode rikuperimi të mbetura',
      resetTitle: 'Reseto faktorin e dytë',
      resetHint:
        'Enrollment-i dhe të gjitha kodet e rikuperimit zerohen: në hyrjen e ardhshme përdoruesi do ta bëjë enrollment-in nga e para. Detyrimi MFA mbetet siç është — një administrator nuk vendos kurrë një sekret, vetëm e zeron.',
      resetConfirm: 'Reseto',
      resetError: 'Faktori i dytë nuk mund të resetohej',
      empty: 'Ende asnjë përdorues i menaxhuar — llogaritë shfaqen këtu sapo ekzistojnë, secila me gjendjen e vet të faktorit të dytë.',

      // Metà B (round #178): provenienza del verdetto efficace, enrollment
      // esterni con lo stato orfano, gruppi che impongono l'obbligo.
      viaSelf: 'Personal',
      viaSelfHint: 'Kontributi personal i llogarisë (flag-u i saj) — e vetmja pjesë që lapsi e modifikon.',
      viaGroupHint: 'Detyrim i trashëguar nga ky grup: heqja e flag-ut personal nuk e liron përdoruesin — ndërhyhet te grupi, në tab-in Grupet.',
      subject: 'Identiteti',
      lastSeenAt: 'Konfirmimi i fundit',
      enrollmentPending: 'Në pritje',
      orphanChip: 'Jetim',
      orphanDirectoryMiss: 'Identiteti nuk është më në direktori',
      orphanRealmRemoved: 'Realm-i është hequr nga TVirt',
      orphanedAt: 'Jetim që nga',
      directoryUuid: 'UUID në direktori',
      externalTitle: 'Enrollment-e të jashtëm',
      externalEmpty: 'Ende asnjë enrollment i jashtëm — lind me hyrjen e parë të një identiteti direktorie me detyrimin MFA.',
      orphanHelp:
        'Një enrollment jetim nuk fshihet kurrë vetë: është material sigurie — mbetet për audit-in dhe, nëse identiteti rishfaqet në direktori, e rigjen faktorin e vet. E vetmja dalje është reset-i administrativ.',
      visibilityHint: 'Enrollment-et e jashtëm banojnë në rrënjën e klasterit: i sheh vetëm kush ka user.read mbi gjithë pemën.',
      orphanResetHint:
        'Rreshti jetim hiqet përfundimisht: askush nuk e reklamon më. Nëse identiteti do të rishfaqet në direktori, do ta bëjë enrollment-in nga e para.',
      enforcingTitle: 'Grupet që e imponojnë MFA-në',
      enforcingSubtitle:
        'Ankora e detyrimit për identitetet e jashtme është grupi: përkthimet e tij të realm-eve thonë te cila popullsi direktorie arrin. Enrollment-i i jashtëm lind me hyrjen e parë të përdoruesit të detyruar.',
      enforcingEmpty: 'Asnjë grup nuk e imponon MFA-në — detyrimi aktivizohet te grupi, nga tab-i Grupet.',
      enforcingError: 'Grupet që e imponojnë MFA-në nuk mund të ngarkoheshin'
    }
  },
  realms: {
    title: 'Realm-et e autentikimit',
    createTitle: 'Krijo realm',
    editTitle: 'Modifiko realm-in',
    name: 'Realm',
    nameHint: 'Domeni që përdoruesit shkruajnë pas @ (example.com) — i pandryshueshëm pas krijimit',
    nameImmutableHint: 'Emri i realm-it është i stampuar në çdo sesion dhe në çdo rresht audit-i që e ka përmendur ndonjëherë — riemërtimi do ta rishkruante historinë',
    kind: 'Tipi',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC dhe SAML vijnë me round-et e ardhshëm — sot një realm është një direktori LDAPv3',

    // Semi-wizard di creazione (round realm-wizard, 2026-08-03): le card dei
    // tipi del passo 1 — ldap vivo, oidc/saml card in roadmap.
    kindCategory: 'Tipi i realm-it',
    kindSelectHint: 'Zgjidh tipin e direktorisë mbi të cilën ky realm do të autentikojë.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Emër përdoruesi dhe fjalëkalim të verifikuar me një bind mbi një direktori LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on nga browser-i i deleguar te një identity provider OpenID Connect — vjen me round-et e ardhshëm.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Single sign-on i ndërmarrjes me asserime SAML 2.0 — vjen me round-et e ardhshëm.'
      }
    },
    tabBind: 'Bind',
    enabled: 'I aktivizuar',
    urls: 'Serverët e direktorisë',
    urlsHint: 'Një URL ldap:// ose ldaps:// për rresht (1–8), të provuara me radhë — failover, kurrë balancim',
    startTls: 'StartTLS',
    verifyCertificate: 'Verifiko certifikatën',
    cleartextWarning: 'Pa ldaps:// ose StartTLS fjalëkalimi i bind-it e përshkon rrjetin në tekst të hapur — i pranueshëm në laborator, kurrë në prodhim.',
    noVerifyWarning: 'Një sesion TLS i paverifikuar nuk autentikon askënd: çaktivizoje verifikimin vetëm ndaj një direktorie që s’mund ta rregullosh.',
    caCertificate: 'Certifikata CA (PEM)',
    caCertificateHint: 'Bundle CA opsional i fiksuar për handshake-un TLS/StartTLS të këtij realm-i; bosh e heq',
    caCertificatePinned: 'E fiksuar',
    connectTimeout: 'Timeout (sekonda)',
    connectTimeoutHint: 'Skadenca për-URL e lidhjes dhe e kërkesës (1–60); me skadimin provohet URL-ja pasuese',
    bindDn: 'Bind DN',
    bindDnHint: 'Service account-i që kryen kërkimin e përdoruesit; bosh = search bind anonim (i refuzuar nga AD)',
    anonymousBind: 'Search bind anonim',
    bindCredential: 'Fjalëkalimi i bind-it (keystore)',
    bindCredentialHint: 'Një zë usernamePassword i keystore-it me fjalëkalimin e bind-it — sekreti nuk jeton kurrë mbi realm-in',
    bindCredentialNone: 'Asnjë (bind anonim)',
    bindCredentialEmpty: 'Asnjë zë usernamePassword në keystore — krijo një te Sistemi > Kredencialet për fjalëkalimin e bind-it.',
    baseDn: 'Base DN',
    baseDnHint: 'Nënpema nga e cila nis kërkimi i përdoruesit (DC=example,DC=com)',
    userFilter: 'Filtri i përdoruesit',
    userFilterHint: '%u zëvendësohet me pjesën lokale të login-it, me escape RFC 4515; direktoritë jo-AD zakonisht duan (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Atributi memberOf',
    memberOfAttributeHint: 'Lexohet vetëm një herë, në hyrje — grupet e papërkthyera injorohen, foleja nuk zgjidhet',
    uuidAttribute: 'Atributi UUID',
    uuidAttributeHint: 'UUID-ja e pandryshueshme në realm (objectGUID në AD, entryUUID në OpenLDAP) — e stampuar në audit krah përdorues@realm',
    displayNameAttribute: 'Atributi i emrit të shfaqur',
    displayNameAttributeHint: 'Përdoret për ta përshëndetur përdoruesin; në mungesë përdoret emri i login-it',
    sudoHint: 'Shkrimet mbi realm-et janë të mbrojtura me sudo: një realm është një derë hyrjeje në platformë',
    deleteBody: 'Përkthimet e grupeve të realm-it ikin bashkë me të; sesionet që ka autentikuar mbeten gjallë deri në skadencë — një realm i fshirë thjesht nuk pranon më askënd.',
    tabConnection: 'Lidhja',
    tabDirectory: 'Direktoria',
    testTitle: 'Provo lidhjen',
    testHint: 'Një sondë konfigurimi, kurrë një autentikim: lidhet, bën bind-in me service account-in dhe — me një emër përdoruesi — e ekzekuton filtrin e përdoruesit.',
    testUsername: 'Emri i përdoruesit (opsional)',
    testUsernameHint: 'Një pjesë lokale mbi të cilën të ekzekutohet filtri i përdoruesit — 1 përputhje është përgjigjja e shëndetshme',
    testRun: 'Ekzekuto provën',
    testError: 'Sonda nuk mund të ekzekutohej',
    testReachable: 'Direktori e arritshme, bind-i i shërbimit i pranuar',
    testUnreachable: 'Direktoria NUK arrihet',
    matchedOne: 'Filtri i përdoruesit gjeti saktësisht 1 zë — përgjigjja e shëndetshme.',
    matchedNone: 'Filtri i përdoruesit nuk gjeti asnjë zë: filtri ose base DN-ja është gabim.',
    matchedMany: 'Filtri i përdoruesit gjeti {count} zëra: nuk është selektiv, dhe hyrjet do të ishin të dykuptimta (të refuzuara).',
    mappingsPointer: 'Me çfarë përkon një grup i jashtëm është një veti e grupit TVirt (përkthimet e tij të realm-eve): pika e së vërtetës jeton në tab-in Grupet.',
    mappingsPointerLink: 'Hap tab-in Grupet',
    rootHomeHint: 'Identitetet e një realm-i të jashtëm jetojnë në rrënjën e klasterit, kurrë në një vDC: lejet caktohen aty ku duhen, me delegimet — mbi grupin ose drejtpërdrejt mbi përdoruesin, saktësisht si për vendasit.'
  },
  credentials: {
    title: 'Kredencialet',
    createTitle: 'Krijo kredencial',
    editTitle: 'Modifiko kredencialin',
    kind: 'Tipi',
    kindUsernamePassword: 'Emër përdoruesi dhe fjalëkalim',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (identitet Ceph)',
    kindHintUsernamePassword: 'I pandryshueshëm. Për storage-t CIFS/SMB — llogaria e mount-it, sekretin e së cilës worker-i e përdor në momentin e mount-it.',
    kindHintIscsiChap: 'I pandryshueshëm. Për autentikimin CHAP iSCSI — emri i përdoruesit = emri CHAP, sekreti = sekreti CHAP.',
    kindHintNvmeDhchap: 'I pandryshueshëm. Për DH-HMAC-CHAP të NVMe over Fabrics — sekreti = blob-i DHHC-1:xx:…; emri i përdoruesit është vetëm një etiketë.',
    kindHintCephx: 'I pandryshueshëm. Për klientët Ceph — emri i përdoruesit = emri i klientit (client.…), sekreti = çelësi base64.',
    kindImmutableHint: 'Tipi është i pandryshueshëm pas krijimit — ta ndryshosh do të thotë një kredencial i ri.',
    username: 'Emri i përdoruesit',
    usernameChap: 'Emri CHAP',
    usernameNvme: 'Etiketa',
    usernameCephx: 'Emri i klientit',
    usernameHint: 'Llogari opsionale së cilës i përket sekreti',
    usernameHintChap: 'Emri CHAP me të cilin initiator-i autentikohet',
    usernameHintNvme: 'Nuk përdoret nga transporti — një etiketë e lirë për shënimet e tua',
    usernameHintCephx: 'Emri i klientit cephx — prefiksi client. tolerohet',
    secret: 'Sekreti',
    secretHint: 'Vetëm në shkrim: përdoret nga konsumatorët, nuk shfaqet më kurrë.',
    secretHintNvmeDhchap: 'Vetëm në shkrim: sekreti DH-HMAC-CHAP host në formën kanonike DHHC-1:xx:… — përdoret nga konsumatorët, nuk shfaqet më kurrë.',
    secretHintCephx: 'Vetëm në shkrim: çelësi cephx base64 — përdoret nga konsumatorët, nuk shfaqet më kurrë.',
    secretEditHint: 'Lëre bosh për të mos e ndryshuar sekretin — plotësimi e rrotullon.',
    createdAt: 'Krijuar',
    inUseError: "'{name}' referohet nga konfigurimi i një storage-i — shkëpute më parë atje.",
    nameHint: 'Shkronja të vogla, shifra dhe vija ndarëse (DNS-1123); unik për scope',

    // Dialog di sola rotazione (round #156): il segreto non ha mai la matita inline.
    rotateTitle: 'Rrotullo sekretin',
    rotateHint: 'Vetëm në shkrim: sekreti i ri e zëvendëson atë të memorizuar — konsumatorët do ta përdorin në mount-in e ardhshëm.',

    // Round #159 (PKI): i tab Certificati e CA.
    tabSecrets: 'Sekretet',
    tabCertificates: 'Certifikatat',
    tabAuthorities: 'Autoritetet e certifikimit',
    certificatesTitle: 'Certifikatat',
    authoritiesTitle: 'Autoritetet e certifikimit',
    caCreateTitle: 'CA e re',
    certCreateTitle: 'Certifikatë e re',
    caMode: 'Origjina',
    caModeGenerate: 'Gjenero me TVirt',
    caModeImport: 'Importo (çelës + certifikatë)',
    certMode: 'Origjina',
    certModeIssue: 'Lësho nga një CA e keystore-it',
    certModeImport: 'Importo (çelës + certifikatë)',
    issuingCa: 'CA lëshuese',
    issuingCaHint: 'Certifikata lind në scope-in e CA-së, me parent-in të regjistruar',
    noCasHint: 'Asnjë CA në keystore — më parë gjenero ose importo një në tab-in CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Subject-i i CA-së: shkronja, shifra, hapësirë, pikë, underscore, vijë ndarëse',
    commonNameCertHint: 'OpenVPN i identifikon klientët nga CN-ja — mbaje unik për CA',
    days: 'Vlefshmëria (ditë)',
    daysCaHint: '1–7300 ditë; 3650 (10 vjet) është default-i',
    daysCertHint: '1–3650 ditë; 365 është default-i',
    keyType: 'Tipi i çelësit',
    keyTypeHint: 'EC P-256 është default-i; RSA për konsumatorë legacy',
    usage: 'Përdorimi',
    usageClient: 'Client (clientAuth)',
    usageServer: 'Server (serverAuth)',
    usageHint: 'Extended key usage për të cilin lëshohet certifikata',
    san: 'Emra alternativë (SAN)',
    sanHint: 'Të ndarë me presje; IP-të literale bëhen zëra IP:, pjesa tjetër DNS:',
    keyPem: 'Çelësi privat (PEM)',
    keyPemHint: 'Vetëm në shkrim: ruhet në keystore, nuk shfaqet më kurrë',
    certPem: 'Certifikata (PEM)',
    certPemHint: 'Certifikata publike që çiftohet me çelësin',
    certPemCaHint: 'Certifikata CA që çiftohet me çelësin (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Lëshuesi',
    parentCa: 'CA lëshuese',
    parentCaImported: 'I importuar — i lëshuar jashtë TVirt',
    serial: 'Seriali',
    fingerprint: 'Fingerprint (SHA-256)',
    validFrom: 'I vlefshëm nga',
    validUntil: 'I vlefshëm deri më',
    expiry: 'Skadenca',
    expired: 'I skaduar',
    expiresInDays: 'Skadon pas {days} d',
    revoked: 'I revokuar',
    revokedAtLabel: 'Revokuar më',
    revokeTitle: 'Revoko certifikatën',
    revokeAction: 'Revoko',
    revokeWarning: 'Revokimi është përfundimtar: seriali hyn në CRL-në e CA-së lëshuese dhe çdo konsumator që i refuzon certifikatat e revokuara (OpenVPN në radhë të parë) do ta hedhë poshtë këtë. Nuk ekziston un-revoke.',
    exportPem: 'Eksporto PEM',
    exportChain: 'Eksporto bundle-in e zinxhirit',
    exportCrl: 'Eksporto CRL',
    materialImmutableHint: 'Materiali X.509 është i pandryshueshëm — rilësho ose ri-importo',
    caInUseError: "'{name}' ka ende certifikata të lëshuara gjallë (ose një storage e referon) — më parë revokoji ose fshiji."
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Vendosja, disponueshmëria dhe afinitetet — ku ekzekutohen VM-të e klasterit dhe nëse duhet të jenë të ndezura',
    loadError: 'Paneli Proximity kërkon store-in e klasterit — gjendja e flotës tani nuk arrihet',
    config: {
      title: 'Konfigurimi',
      subtitle: 'Politika e vendosjes në nivel klasteri',
      save: 'Ruaj',
      saveError: 'Konfigurimi u refuzua',
      strategy: 'Strategjia e zgjedhjes',
      strategy_leastUsedResources: 'Më pak burime të përdorura',
      strategy_leastVms: 'Më pak VM',
      strategy_random: 'E rastësishme',
      strategyLeastUsedResourcesHint: 'Mes kandidatëve të vlefshëm, nyja me më shumë RAM të përdorshëm të mbetur (totali i vëzhguar − rezerva host − VM-të e ndezura), angazhimi vCPU si shkëputje barazimi. Deterministike me të njëjtat të dhëna.',
      strategyLeastVmsHint: 'Mes kandidatëve të vlefshëm, nyja me më pak VM të ndezura; barazimet zgjidhen sipas emrit. Deterministike me të njëjtat të dhëna.',
      strategyRandomHint: 'Uniformisht e rastësishme mes kandidatëve të vlefshëm.',
      liveness: 'Pragu i gjallërisë së nyjeve (sekonda)',
      livenessHint: 'Një anëtar i heshtur përtej pragut është i paarritshëm: i përjashtuar nga vendosja dhe — nëse jo në mirëmbajtje — i konsideruar i vdekur nga decider-i HA, që e rrethon dhe i rinis gjetkë VM-të e tij HA.',
      decider: 'Decider HA',
      deciderNone: 'ende i pazgjedhur'
    },
    nodesTitle: 'Nyjet',
    nodesSubtitle: 'Gjallëria dhe kapaciteti empirik — RAM i përdorshëm = totali − baza − e angazhuara',
    nodeCol: 'Nyja',
    stateCol: 'Gjendja',
    ramCol: 'RAM (totali − baza − e angazhuara)',
    usableCol: 'I përdorshëm',
    vmsCol: 'Ngarkesa',
    neverSeen: 'e paparë ndonjëherë',
    freshChip: 'e arritshme',
    staleChip: 'e paarritshme',
    attestedChip: 'e atestuar e fikur',
    ramFormula: 'totali − baza − e angazhuara',
    haTitle: 'Disponueshmëria e lartë',
    haSubtitle: 'VM-të me flag HA janë "gjithmonë të ndezura": TVirt i rinis pas çdo ndalimi të pakërkuar — e njëjta nyjë me backoff, një nyjë tjetër kur e tyrja vdes (vetëm storage i përbashkët).',
    haNone: 'Asnjë VM s’e ka ende flag-un HA — aktivizoje këtu ose te detajet e VM-së.',
    haVmCol: 'Makina virtuale',
    haStateCol: 'Gjendja',
    haRestartsCol: 'Rinisje HA',
    haLastEventCol: 'Ngjarja e fundit',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'Ndryshimi HA u refuzua',
    rules: {
      title: 'Rregullat e afinitetit',
      createTitle: 'Rregull i ri afërsie',
      editTitle: 'Modifiko rregullin',
      nameHint: 'Shkronja të vogla, shifra dhe vija ndarëse (etiketë DNS)',
      vms: 'Makinat virtuale',
      vmsHint: 'Të paktën dy VM — rregulli kufizon ku ekzekutohen njëra në raport me tjetrën',
      type: 'Tipi',
      affinity: 'Afinitet (bashkë)',
      antiAffinity: 'Anti-afinitet (të ndara)',
      typeAffinityHint: 'VM-të duhet të ekzekutohen në të NJËJTËN nyjë.',
      typeAntiAffinityHint: 'VM-të duhet të ekzekutohen në nyje TË NDRYSHME — çifti klasik HA.',
      mode: 'Mënyra',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Shkeljet e refuzojnë operacionin (nisje, migrim, failover) me një gabim që flet qartë.',
      modeSoftHint: 'Preferencë, kurrë bllokuese: një vendosje në shkelje vazhdon me një paralajmërim të dukshëm.',
      satisfied: 'Vendosja',
      satisfiedYes: 'e respektuar',
      satisfiedNo: 'e shkelur',

      // Dialog standard (round #156): le violazioni hanno la loro riga, non un tooltip.
      violations: 'Shkeljet',
      noViolations: 'Asnjë'
    },
    events: {
      title: 'Ngjarjet HA',
      subtitle: 'Ditari i disponueshmërisë — rinisje, fencing, failover dhe kapërcimet e ndershme',
      none: 'Ende asgjë.',
      when: 'Kur',
      kind: 'Ngjarja',
      target: 'Objekti',
      detail: 'Detaji',
      kindRestarted: 'rinisje HA',
      kindGaveUp: 'dorëzim (crash loop)',
      kindNodeAttested: 'nyjë e rrethuar',
      kindFailedOver: 'failover',
      kindNoCandidate: 'asnjë kandidat',
      kindStorageLocalSkip: 'e kapërcyer (storage lokal)',
      kindZombieFenced: 'zombie i asgjësuar'
    }
  }
}
